// Generated by PowerAlpha scripts/financier/generate_contract.py; do not edit.
import z from 'zod';
export const pricingInputs = [
    {
        field: 'Plant_Configuration__c',
        label: 'Plant Configuration',
        kind: 'array',
        unit: '',
        options: ['PV', 'BESS', 'H2ES', 'Wind'],
    },
    {
        field: 'Interconnection_Size_MW_ac__c',
        label: 'Interconnection Size MW ac',
        kind: 'number',
        unit: 'MW',
        precision: 5,
        scale: 1,
    },
    {
        field: 'PV_Inverter_Capacity_MW_ac__c',
        label: 'PV Inverter Capacity MW ac',
        kind: 'number',
        unit: 'MW',
        precision: 6,
        scale: 2,
    },
    {
        field: 'Li_ion_Storage_Power_MW_ac__c',
        label: 'Li ion Storage Power MW ac',
        kind: 'number',
        unit: 'MW',
        precision: 7,
        scale: 2,
    },
    {
        field: 'Li_ion_Storage_Capacity_MWh_ac__c',
        label: 'Li ion Storage Capacity MWh ac',
        kind: 'number',
        unit: 'MWh',
        precision: 8,
        scale: 2,
    },
    {
        field: 'BESS_Cycles__c',
        label: 'BESS Cycles',
        kind: 'number',
        unit: 'cycles/year',
        precision: 4,
        scale: 0,
    },
    {
        field: 'Wind_Capacity_MW_ac__c',
        label: 'Wind Capacity MW ac',
        kind: 'number',
        unit: 'MW',
        precision: 6,
        scale: 2,
    },
    {
        field: 'Delivery_Point__c',
        label: 'Delivery Point',
        kind: 'string',
        unit: '',
        options: ['Bus Bar', 'Hub settled'],
    },
    {
        field: 'PPA_Type__c',
        label: 'PPA Type',
        kind: 'string',
        unit: '',
        options: ['As Avail', 'Capacity Payment', 'As Avail + Capacity Payment', 'Structured Product'],
    },
    {
        field: 'PTC_Base_Rate_MWh__c',
        label: 'PTC Base Rate MWh',
        kind: 'number',
        unit: 'USD/MWh',
        precision: 4,
        scale: 2,
    },
    {
        field: 'PV_PPA_Term__c',
        label: 'PV PPA Term',
        kind: 'number',
        unit: 'years',
        precision: 2,
        scale: 0,
    },
    {
        field: 'BESS_Term__c',
        label: 'BESS Term',
        kind: 'number',
        unit: 'years',
        precision: 2,
        scale: 0,
    },
    {
        field: 'Merchant_Tail_Term__c',
        label: 'Merchant Tail Term',
        kind: 'number',
        unit: 'years',
        precision: 2,
        scale: 0,
    },
    { field: 'COD__c', label: 'COD', kind: 'date', unit: '' },
    {
        field: 'PPA_Price_MWh__c',
        label: 'PPA Price MWh',
        kind: 'number',
        unit: 'USD/MWh',
        precision: 5,
        scale: 2,
    },
    {
        field: 'PPA_Adder__c',
        label: 'PPA Adder',
        kind: 'number',
        unit: 'USD/MWh',
        precision: 4,
        scale: 2,
    },
    {
        field: 'PPA_Escalator__c',
        label: 'PPA Escalator',
        kind: 'number',
        unit: '%',
        precision: 4,
        scale: 2,
    },
    {
        field: 'Capacity_Payment_MW_month__c',
        label: 'Capacity Payment MW month',
        kind: 'number',
        unit: 'USD/MW/month',
        precision: 7,
        scale: 2,
    },
    {
        field: 'BESS_Capacity_Payment_Escalator__c',
        label: 'BESS Capacity Payment Escalator',
        kind: 'number',
        unit: '%',
        precision: 4,
        scale: 2,
    },
    {
        field: 'BTA_Total_PV_Costs__c',
        label: 'BTA Total PV Costs',
        kind: 'number',
        unit: 'USD',
        precision: 12,
        scale: 2,
    },
    {
        field: 'BTA_Total_BESS_Costs__c',
        label: 'BTA Total BESS Costs',
        kind: 'number',
        unit: 'USD',
        precision: 12,
        scale: 2,
    },
    {
        field: 'BTA_Total_Project_Costs__c',
        label: 'BTA Total Project Costs',
        kind: 'number',
        unit: 'USD',
        precision: 12,
        scale: 2,
    },
    {
        field: 'BTA_Margin__c',
        label: 'BTA Margin',
        kind: 'number',
        unit: 'USD',
        precision: 12,
        scale: 2,
    },
    {
        field: 'BTA_Margin_perc__c',
        label: 'BTA Margin perc',
        kind: 'number',
        unit: '%',
        precision: 4,
        scale: 2,
    },
    {
        field: 'BTA_Price__c',
        label: 'BTA Price',
        kind: 'number',
        unit: 'USD',
        precision: 10,
        scale: 0,
    },
    { field: 'Dev_Fee__c', label: 'Dev Fee', kind: 'number', unit: 'USD', precision: 9, scale: 0 },
    { field: 'LATIRR__c', label: 'LATIRR', kind: 'number', unit: '%', precision: 5, scale: 3 },
    {
        field: 'Contracted_LATIRR__c',
        label: 'Contracted LATIRR',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
    {
        field: 'Tax_Efficient_UATIRR__c',
        label: 'Tax Efficient UATIRR',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
    {
        field: 'Tax_Efficient_Contracted_UATIRR__c',
        label: 'Tax Efficient Contracted UATIRR',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
    {
        field: 'PV_of_Contracted_CFs__c',
        label: 'PV of Contracted CFs',
        kind: 'number',
        unit: 'USD',
        precision: 10,
        scale: 0,
    },
    {
        field: 'PV_of_Merchant_CFs__c',
        label: 'PV of Merchant CFs',
        kind: 'number',
        unit: 'USD',
        precision: 10,
        scale: 0,
    },
    {
        field: 'Unl_Cash_Yield_15_Yr__c',
        label: 'Unl Cash Yield 15 Yr',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
    {
        field: 'Unl_Cash_Yield_20_Yr__c',
        label: 'Unl Cash Yield 20 Yr',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
    { field: 'Debt__c', label: 'Debt', kind: 'number', unit: '%', precision: 5, scale: 3 },
    {
        field: 'Tax_Equity__c',
        label: 'Tax Equity',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
    {
        field: 'Sponsor_Equity__c',
        label: 'Sponsor Equity',
        kind: 'number',
        unit: '%',
        precision: 5,
        scale: 3,
    },
];
export const pricingInputFieldSchema = z.enum([
    'Plant_Configuration__c',
    'Interconnection_Size_MW_ac__c',
    'PV_Inverter_Capacity_MW_ac__c',
    'Li_ion_Storage_Power_MW_ac__c',
    'Li_ion_Storage_Capacity_MWh_ac__c',
    'BESS_Cycles__c',
    'Wind_Capacity_MW_ac__c',
    'Delivery_Point__c',
    'PPA_Type__c',
    'PTC_Base_Rate_MWh__c',
    'PV_PPA_Term__c',
    'BESS_Term__c',
    'Merchant_Tail_Term__c',
    'COD__c',
    'PPA_Price_MWh__c',
    'PPA_Adder__c',
    'PPA_Escalator__c',
    'Capacity_Payment_MW_month__c',
    'BESS_Capacity_Payment_Escalator__c',
    'BTA_Total_PV_Costs__c',
    'BTA_Total_BESS_Costs__c',
    'BTA_Total_Project_Costs__c',
    'BTA_Margin__c',
    'BTA_Margin_perc__c',
    'BTA_Price__c',
    'Dev_Fee__c',
    'LATIRR__c',
    'Contracted_LATIRR__c',
    'Tax_Efficient_UATIRR__c',
    'Tax_Efficient_Contracted_UATIRR__c',
    'PV_of_Contracted_CFs__c',
    'PV_of_Merchant_CFs__c',
    'Unl_Cash_Yield_15_Yr__c',
    'Unl_Cash_Yield_20_Yr__c',
    'Debt__c',
    'Tax_Equity__c',
    'Sponsor_Equity__c',
]);
export const pricingConfidenceSchema = z.enum(['low', 'medium', 'high']);
export const pricingExtractedInputSchema = z.discriminatedUnion('field', [
    z.strictObject({
        field: z.enum(['Plant_Configuration__c']),
        value: z.array(z.enum(['PV', 'BESS', 'H2ES', 'Wind'])).nullable(),
        unit: z.literal(''),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum([
            'Interconnection_Size_MW_ac__c',
            'PV_Inverter_Capacity_MW_ac__c',
            'Li_ion_Storage_Power_MW_ac__c',
            'Wind_Capacity_MW_ac__c',
        ]),
        value: z.number().finite().nullable(),
        unit: z.literal('MW'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['Li_ion_Storage_Capacity_MWh_ac__c']),
        value: z.number().finite().nullable(),
        unit: z.literal('MWh'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['BESS_Cycles__c']),
        value: z.number().finite().nullable(),
        unit: z.literal('cycles/year'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['Delivery_Point__c', 'PPA_Type__c']),
        value: z.string().nullable(),
        unit: z.literal(''),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['PTC_Base_Rate_MWh__c', 'PPA_Price_MWh__c', 'PPA_Adder__c']),
        value: z.number().finite().nullable(),
        unit: z.literal('USD/MWh'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['PV_PPA_Term__c', 'BESS_Term__c', 'Merchant_Tail_Term__c']),
        value: z.number().finite().nullable(),
        unit: z.literal('years'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['COD__c']),
        value: z.iso.date().nullable(),
        unit: z.literal(''),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum([
            'PPA_Escalator__c',
            'BESS_Capacity_Payment_Escalator__c',
            'BTA_Margin_perc__c',
            'LATIRR__c',
            'Contracted_LATIRR__c',
            'Tax_Efficient_UATIRR__c',
            'Tax_Efficient_Contracted_UATIRR__c',
            'Unl_Cash_Yield_15_Yr__c',
            'Unl_Cash_Yield_20_Yr__c',
            'Debt__c',
            'Tax_Equity__c',
            'Sponsor_Equity__c',
        ]),
        value: z.number().finite().nullable(),
        unit: z.literal('%'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum(['Capacity_Payment_MW_month__c']),
        value: z.number().finite().nullable(),
        unit: z.literal('USD/MW/month'),
        confidence: pricingConfidenceSchema,
    }),
    z.strictObject({
        field: z.enum([
            'BTA_Total_PV_Costs__c',
            'BTA_Total_BESS_Costs__c',
            'BTA_Total_Project_Costs__c',
            'BTA_Margin__c',
            'BTA_Price__c',
            'Dev_Fee__c',
            'PV_of_Contracted_CFs__c',
            'PV_of_Merchant_CFs__c',
        ]),
        value: z.number().finite().nullable(),
        unit: z.literal('USD'),
        confidence: pricingConfidenceSchema,
    }),
]);
//# sourceMappingURL=inputs.generated.js.map